import React, { Component } from 'react'
import PropTypes from 'prop-types'

/**
 * @class AssignTaskOption
 * @description Displays a type of Task to assign
 */
class AssignTaskOption extends Component {
  static propTypes = {
    assigned: PropTypes.bool.isRequired,
    data: PropTypes.any.isRequired,
    onClick: PropTypes.func.isRequired,
    tasks: PropTypes.array,
  }

  static defaultProps = {
    tasks: [],
  }

  render() {
    const { assigned, data: { content, name, type }, tasks, onClick } = this.props

    const numberComplete = tasks.filter(item => item.completed)

    return (
      <tr>
        <td>{name}<br /><span className="text-muted small">{content}</span></td>
        <td className="small">{tasks.length > 0 ? `${numberComplete.length} of ${tasks.length}` : 'N/A'}</td>
        <td className="text-info" role="button" onClick={() => onClick(name, type)}>
          {assigned ? 'Edit' : 'Assign'}
        </td>
      </tr>
    )
  }
}

export default AssignTaskOption



// WEBPACK FOOTER //
// ./src/routes/authenticated/ParentDashboard/components/AssignTaskOption.js